import { Navigation } from "@/components/Navigation"
import { Footer } from "@/components/Footer"
import { PartnersSection } from "@/components/PartnersSection"
import { PageFAQ } from "@/components/PageFAQ"
import { partnersFAQs } from "@/data/faqData"

import { SEO } from "@/components/SEO"

const Partners = () => {
  return (
    <div className="min-h-screen bg-background">
      <SEO
        title="Strategic Partnerships | RSA Tech Group"
        description="Accelerating innovation through strategic alliances with industry leaders. See our technology and service partners."
        image="https://images.unsplash.com/photo-1521737604893-d14cc237f11d?auto=format&fit=crop&q=80&w=2600"
      />
      <Navigation />
      <div className="pt-20">
        <PartnersSection />
      </div>
      <PageFAQ
        faqs={partnersFAQs}
        title="Partners FAQs"
        subtitle="Common questions about our technology partnerships"
        variant="muted"
      />
      <Footer />
    </div>
  )
}

export default Partners
